export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7fd5e1e6e0fbdffe518bf3baf7a54b12f92351c255&name=fetchTypeahead!'